import React, { useEffect, useState } from "react";
import axios from "axios";
import './sidebar.css'
import RateCalculator from "../calculator/RateCalculator";

const Sidebar = () => {
  const [newsData, setNewsData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      const formattedYesterday = yesterday.toISOString().split("T")[0];

      try {
        const res = await axios.get(
          `https://newsdata.io/api/1/latest?apikey=pub_ab7db997835141b7a95250c3c0cf57da&q=gold%20rate%20and%20silver%20rate&country=in&language=en`
        );
        // const res = await axios.get(
        //   `https://newsapi.org/v2/everything?q=gold%20AND%20India&language=en&from=${formattedYesterday}&sortBy=publishedAt&apiKey=d6dfc4513acf413cb4406b89a82bc0a7`
        // );
        // const res = await axios.get(
        //   `https://gnews.io/api/v4/search?q=gold&lang=en&country=in&max=10&apikey=197836aefe5d224564223fa9660e5c0e`
        // );

        setNewsData(res.data.results);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {

  }, [newsData]);
  // console.log(newsData);

  return (
    <>
      <section className="sidebar">
        <div className="container">
          <div className="row">
            <RateCalculator />
            <div className="latest-news">
              <h3>Latest News</h3>

              <div className="news">
                {
                  newsData?.slice(0, 5).map((val, index) => {
                    const { link, title, image_url } = val
                    return (
                      <div className="box" key={index}>
                        <div className="content">
                          <div className="image">
                            <a href={link} target="_blank" aria-label={title}>
                              <img src={image_url} alt={title} />
                            </a>
                          </div>
                          <div className="detail">
                            <a href={link} target="_blank" rel="noopener noreferrer" aria-label={title}>{title}</a>
                          </div>
                        </div>
                      </div>
                    )
                  })
                }
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Sidebar;
